module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms13x-detail-tab5"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab5"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STDEMPC5']['10']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab5"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-xs-12 col-md-4 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix"
  }, [_c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC5']['20']))])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, _vm._l((_vm.data.table1.rows), function(table1Row) {
    return _c('div', {
      staticClass: "table-row clear-padding clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_c('a', {
      attrs: {
        "href": _vm.genUrl(table1Row.codapp),
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(table1Row.detail))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix"
  }, [_c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC5']['30']))])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, _vm._l((_vm.data.table2.rows), function(table2Row) {
    return _c('div', {
      staticClass: "table-row clear-padding clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_c('a', {
      attrs: {
        "href": _vm.genUrl(table2Row.codapp),
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(table2Row.detail))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix"
  }, [_c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC5']['40']))])]), _vm._v(" "), _c('div', {
    staticClass: "data-box clearfix"
  }, _vm._l((_vm.data.table3.rows), function(table3Row) {
    return _c('div', {
      staticClass: "table-row clear-padding clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 body-table-left color-skin"
    }, [_c('a', {
      attrs: {
        "href": _vm.genUrl(table3Row.codapp),
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(table3Row.detail))])])])])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c226e1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms13x/detailTab5.vue
// module id = 3541
// module chunks = 1